import { Card, Col, Row } from 'reactstrap';
import { PetitionsDetailResponse } from '../../../types';
import { StudentPetitionSummary } from './StudentPetitionSummary';
import { StudentPetitionInfo } from './StudentPetitionInfo';
import { SectionTitle } from '../../../../../../../components/text';
import TextBox from '../../../../../../StudentsPetitionsDetail/parts/TextBox';
import { useTexts } from '../../../hooks/useTexts';

type Props = {
  data: PetitionsDetailResponse;
};

export function Detail({ data }: Props) {
  const texts = useTexts().detail;
  return (
    <Card className="p-4 mt-2 mx-3">
      <section className="petition-summary mb-4">
        <Row>
          <Col xs={12} sm={12}>
            <div className="mb-3">
              <SectionTitle text={texts.resume.title} />
            </div>
            <div className="mb-3">
              <p>{texts.resume.petitionResumeSubTitle}</p>
            </div>
          </Col>
          <Col xs={12} sm={12}>
            <StudentPetitionSummary
              {...{
                petitionTitle: data.title,
                petitionType: data.type.name,
                studyPlan: data.studyPlanVersion.name,
                petitionDate: data.createdAt,
                evaluationDate: data.evaluationDate,
                section: data.section,
                paymentAmount: data.payment,
              }}
            />
          </Col>
        </Row>
      </section>

      <section className="petition-info mb-4">
        <Card className="petition-info__subject mb-3">
          <Row>
            <Col md={12} className="mb-3">
              <SectionTitle text={texts.reason.reasonTitle} />
            </Col>
            <Col md={12} className="mb-3">
              <TextBox text={data.description} />
            </Col>
            <Col md={12} className="mb-3">
              <StudentPetitionInfo
                currentStatus={data.status}
                lastUpdate={data.lastUpdate.comment}
                lastUpdatedAt={data.lastUpdate.updatedAt}
                downloadFiles={data.pdfFiles}
                downloadFileResponse={
                  data?.fileResponse && data.linkedFileResponse
                    ? {
                        name: data.linkedFileResponse.name,
                        url: data.fileResponse.url,
                      }
                    : undefined
                }
                downloadFileVoucher={
                  data?.voucherDownloadURL
                    ? {
                        name: texts.downloads.voucher,
                        url: data.voucherDownloadURL,
                      }
                    : undefined
                }
                paidAt={data.paidAt}
              />
            </Col>
          </Row>
        </Card>
      </section>
    </Card>
  );
}
